import { mergeDocuments, transformIntoDocuments, } from "@topyourthree/datastore/core";
import { transformSeoNavbar } from "./seo-navbar.transformers";
export function SeoNavbarReducer(state = {}, action) {
    switch (action.type) {
        case "API_FETCH_SUCCESS": {
            if (action.payload.type === "seoNavbar") {
                const { result, ref, order } = action.payload;
                return mergeDocuments(state, transformIntoDocuments([result], transformSeoNavbar), order, ref);
            }
            return state;
        }
        default:
            return state;
    }
}
